import script from "./stepWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./stepWidget.vue?vue&type=script&setup=true&lang=ts"

import "./stepWidget.vue?vue&type=style&index=0&id=6281a8c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6281a8c9"]])

export default __exports__